/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TargetAttributoDefinizione } from './target-attributo-definizione';
import { UiWidget } from './ui-widget';
import { BindingTarget } from './binding-target';


export interface TipoPraticaAttributoListFilter { 
    target?: TargetAttributoDefinizione;
    binding_target?: BindingTarget;
    ui_widget?: UiWidget;
    obbligatorio?: boolean;
    q?: string;
}



